import { playNotificationSound } from './sound';

export async function requestPermission(): Promise<boolean> {
	const result = await Notification.requestPermission();
	return result === "granted";
}

export function notify(
	title: string,
	body: string,
	silent: boolean = false,
	soundType?: 'focus' | 'break' | 'movement'
) {
	if (Notification.permission !== "granted") {
		return;
	}

	// Always use silent:true for the notification itself - we handle sound separately
	new Notification(title, { body, silent: true });

	// Play generated sound if not silent and type specified
	if (!silent && soundType) {
		playNotificationSound(soundType);
	}
}
